module.exports = require('@theia/request');
